import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type GroupCreationRows = {
  label: vp.GroupCreationLabel;
  id: vp.GroupCreationId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'input' | 'select' | 'toggle';
  placeholder: string;
  getSelectOptions: () => { [key: string]: string };
};

export const buildGroupCreationRows = (country: string): GroupCreationRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Create.Form' });
  const ProductOptions: { [key: string]: string } = {
    eft: 'EFT',
  };
  const ProductOptionsUS: { [key: string]: string } = {
    ach: 'ACH',
  };

  const CurrencyOptions = {
    ...vp.CURRENCY_SELECT_OPTIONS,
  };

  return [
    {
      label: t('GroupName.label'),
      id: vp.GroupCreationId.GroupName,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: t('GroupName.placeholder'),
      getSelectOptions: () => ({}),
    },
    {
      label: t('Description.label'),
      id: vp.GroupCreationId.Description,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: t('Description.placeholder'),
      getSelectOptions: () => ({}),
    },
    {
      label: t('Service.label'),
      id: vp.GroupCreationId.Service,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: t('Service.placeholder'),
      getSelectOptions: () => (country === 'US' ? ProductOptionsUS : ProductOptions),
    },
    {
      label: t('Currency.label'),
      id: vp.GroupCreationId.Currency,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: t('Currency.placeholder'),
      getSelectOptions: () => (country === 'US' ? vp.US_CURRENCY_ONLY : CurrencyOptions),
    },
  ];
};
